import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=4d471c53&scoped=true"
import script from "./Message.vue?vue&type=script&lang=js"
export * from "./Message.vue?vue&type=script&lang=js"
import style0 from "./Message.vue?vue&type=style&index=0&id=4d471c53&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d471c53",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d471c53')) {
      api.createRecord('4d471c53', component.options)
    } else {
      api.reload('4d471c53', component.options)
    }
    module.hot.accept("./Message.vue?vue&type=template&id=4d471c53&scoped=true", function () {
      api.rerender('4d471c53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Message.vue"
export default component.exports